import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import common from './common/common'//引用文件
import { createPinia, PiniaVuePlugin } from 'pinia'
import piniaPersist from 'pinia-plugin-persist'

if (process.env.NODE_ENV !== 'production') {
  const VConsole = require('vconsole')
  new VConsole()
}


// import echarts from 'echarts';
// import china from 'echarts/map/json/china.json'
// echarts.registerMap('china', china)
// Vue.prototype.$echarts = echarts


// import echarts from 'echarts'
//引入echarts
// import * as echarts from 'echarts'//在import的后面，echarts的前面加一个 * as
//vue全局注入echarts
// Vue.prototype.$echarts = echarts;
Vue.use(PiniaVuePlugin)
const pinia = createPinia()
pinia.use(piniaPersist)
Vue.prototype.COMMON = common//挂载到Vue实例上面

Vue.config.productionTip = false



new Vue({
  router,
  store,
  pinia,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  render: h => h(App)
}).$mount('#app')


